import "./BillingClient.scss";
import { FormattedMessage } from "react-intl";
import { Typography } from "core/typography/Typography";
import { BILLING_CLIENT_FORM_LABELS } from "constants/forms";
import {
  renderInputBillingCity,
  renderInputBillingPostalCode,
  renderInputBillingAddress,
  renderInputCountry,
} from "../CommonInputs";
import InfoContext from "pages/InfoContext";
import { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const BillingClientCorporateInfoForm = ({
  control,
  register,
  errors,
  readOnly = false,
  setValue,
  watch,
  cellHighlight,
}) => {
  const billing_country = watch("billing_country", []);

  const { dataCountry, sirenData, lang } = useContext(InfoContext);

  useEffect(() => {
    if (!_.isEmpty(sirenData)) {
      let sirenCountry = sirenData?.country?.toUpperCase();
      let country = dataCountry?.find(
        (country) => country.name === sirenCountry
      );
      if (country) setValue("billing_country", country.id);
    }
  }, [sirenData]);

  return (
    <div className="billing-info-wrapper">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="billing_infos"
            defaultMessage="INFOS FACTURATION"
          />
        }
      />
      <div className="billing-info">
        <div className="center-block">
          <div className="line-1">
            <div
              className={`cell-padding ${
                !watch("billing_city") && cellHighlight && "errorCellColor"
              }`}
            >
              {renderInputBillingCity({
                control,
                errors,
                label: BILLING_CLIENT_FORM_LABELS.billing_city,
                placeholder: BILLING_CLIENT_FORM_LABELS.billing_city,
                readOnly,
                register,
              })}
            </div>
            <div
              className={`cell-padding ${
                !watch("billing_postal_code") &&
                cellHighlight &&
                "errorCellColor"
              }`}
            >
              {renderInputBillingPostalCode({
                control,
                errors,
                label: BILLING_CLIENT_FORM_LABELS.billing_postal_code,
                placeholder: BILLING_CLIENT_FORM_LABELS.billing_postal_code,
                readOnly,
                register,
              })}
            </div>
          </div>
          <div className="line-2">
            <div
              className={`cell-padding ${
                !watch("billing_country") && cellHighlight && "errorCellColor"
              }`}
            >
              {renderInputCountry({
                control,
                errors,
                label: BILLING_CLIENT_FORM_LABELS.billing_country,
                placeholder: BILLING_CLIENT_FORM_LABELS.billing_country,
                readOnly,
                register,
                countries: dataCountry,
                value: watch("billing_country"),
                setValue,
                name: "billing_country",
                lang,
              })}
            </div>
          </div>
        </div>
        <div className="corner-right">
          <div
            className={`cell-padding ${
              !watch("billing_address") && cellHighlight && "errorCellColor"
            }`}
          >
            {renderInputBillingAddress({
              control,
              errors,
              label: BILLING_CLIENT_FORM_LABELS.billing_address,
              placeholder: BILLING_CLIENT_FORM_LABELS.billing_address,
              readOnly,
              register,
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingClientCorporateInfoForm;

BillingClientCorporateInfoForm.propTypes = {
  control: PropTypes.object,
  register: PropTypes.func,
  setValue: PropTypes.func,
  errors: PropTypes.object,
  readOnly: PropTypes.bool,
  watch: PropTypes.func,
  cellHighlight: PropTypes.bool,
};
